import React from "react";
import { Link } from "react-router-dom";
import TargetLogo from "./TargetLogo";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="w-full"
      style={{ background: "linear-gradient(180deg,#8ed3f5 0%,#79c6f0 100%)" }}
    >
      <div className="mx-auto flex max-w-3xl items-center gap-3 px-3 py-3 sm:py-4">
        <Link to="/" data-testid="header-home-link" className="shrink-0">
          <TargetLogo size={54} />
        </Link>
        <Link to="/" className="min-w-0 flex-1">
          <span
            className="block truncate text-2xl font-extrabold leading-tight text-[#0c1420] sm:text-4xl"
            data-testid="site-title"
          >
            Bhutan Morning Teer
          </span>
        </Link>
      </div>
    </header>
  );
}
